import React from 'react';
import { Modal } from 'react-bootstrap';

import CustomerListContainer from '../containers/CustomerListContainer.jsx';
import CustomerEditContainer from '../containers/CustomerEditContainer.jsx';

const CustomersComponent = ({
	// state
	showModal,
	// dispatch
	closeModal
}) => (

		<div>
			<h4>客戶管理</h4>
			<CustomerListContainer />
			<Modal show={showModal} onHide={closeModal} backdrop="static">
				<Modal.Header closeButton />
				<Modal.Body>
					<CustomerEditContainer />
				</Modal.Body>
			</Modal>
		</div>

	);

export default CustomersComponent;


// WEBPACK FOOTER //
// ./src/components/CustomersComponent.jsx